import * as dataSharingSharesCommands from '@DataSharing/Shares/commands-vue-composables'
import * as dataSharingSharesQueries from '@DataSharing/Shares/queries-vue-composables'

export function useAccessSharePage(){
	return {
		useAccessShareQuery: dataSharingSharesQueries.useAccessShareQueryV1,
		useSendEmailConfirmationCommand: dataSharingSharesCommands.useSendEmailConfirmationCommandV1,
	}
}

export function useAdminActiveSharesPage(){
	return {
		useActiveSharesQuery: dataSharingSharesQueries.useActiveSharesQueryV1,
	}
}

export function useResourcePage(){
	return {
		useResourceSharesQuery: dataSharingSharesQueries.useResourceSharesQueryV1,
	}
}

export function useShareNotificationPage(){
	return {
		useSendNotificationCommand: dataSharingSharesCommands.useSendNotificationCommandV1,
		useShareNotificationQuery: dataSharingSharesQueries.useShareNotificationQueryV1,
	}
}

export function useSharePage(){
	return {
		useDataShareEmailsProvidersQuery: dataSharingSharesQueries.useDataShareEmailsProvidersQueryV1,
		useDeleteShareCommand: dataSharingSharesCommands.useDeleteShareCommandV1,
		useEmailsAndGroupsQuery: dataSharingSharesQueries.useEmailsAndGroupsQueryV1,
		usePauseSharingCommand: dataSharingSharesCommands.usePauseSharingCommandV1,
		useResumeSharingCommand: dataSharingSharesCommands.useResumeSharingCommandV1,
		useShareDataCommand: dataSharingSharesCommands.useShareDataCommandV1,
		useShareQuery: dataSharingSharesQueries.useShareQueryV1,
	}
}

